import { getMonitoring } from './monitoring.ts';
import type { MonitoringErrorContext } from './monitoring.types.ts';

const REPORT_THROTTLE_WINDOW_MS = 5 * 60 * 1000;

const reportedAtBySite = new Map<string, number>();

export interface ReportOnceOptions {
  windowMs?: number;
}

export function reportOnce(
  siteKey: string,
  errorFactory: () => Error,
  context: MonitoringErrorContext,
  { windowMs = REPORT_THROTTLE_WINDOW_MS }: ReportOnceOptions = {}
): void {
  const now = Date.now();
  const lastReportedAt = reportedAtBySite.get(siteKey);
  if (lastReportedAt !== undefined && now - lastReportedAt < windowMs) return;
  reportedAtBySite.set(siteKey, now);
  getMonitoring().captureError(errorFactory(), context);
}

export function __resetReportOnceForTests(): void {
  reportedAtBySite.clear();
}
